export default __webpack_public_path__ + "static/media/womenphoto.881da1fc.jpg";